<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-card>
          <div class="f-right border-b">
            <div class="flex1">巡查区域管理</div>
            <el-button v-hasPermi="['safe:safearea:edit']" icon="el-icon-plus" type="primary" @click="addList()">新增</el-button>
            <el-button class="ml10" type="primary" v-hasPermi="['safe:safearea:edit']" @click="onSubmit">保存</el-button>
          </div>
          <!-- <ul class="tab-wrap mt20" >
      <li
        :class="`tab-btn ${nowIndex == index && 'active'}`"
        @click="changeTab(index,tab)"
        v-for="(tab, index) in tabList"
      >
        {{tab.name }}
      </li>
    </ul> -->

          <table v-if="tabList[nowIndex].id == 0" class="common-table mt20">
            <thead>
              <tr class="mt10">
                <th>巡查区域</th>
                <!-- <th>区域唯一标识</th> -->
                <th v-hasPermi="['safe:safearea:edit']">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in list" :key="index">
                <td class="common-add">
                  <el-input placeholder="请输入" v-model="item.x_company_area"></el-input>
                </td>
                <!-- <td class="common-add">
                <el-input
                  placeholder="请输入"
                  v-model="item.x_company_id"
                ></el-input>
              </td> -->
                <td class="td-btn">
                  <a class="clear-data" @click="del(index)">
                    <i class="icon-tr-delete"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <table v-if="tabList[nowIndex].id == 1" class="common-table mt20">
            <thead>
              <tr class="mt10">
                <th>巡查区域</th>
                <th v-hasPermi="['safe:safearea:edit']">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in listWW" :key="index">
                <td class="common-add">
                  <el-input placeholder="请输入" v-model="item.x_company_area"></el-input>
                </td>

                <td class="td-btn">
                  <a class="clear-data" @click="del1(index)">
                    <i class="icon-tr-delete"></i>
                  </a>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="btn-box" v-hasPermi="['safe:safearea:edit']">
            <div class="l-btn" @click="onSubmit">保存</div>
            <div class="l-btn ml20" @click="$router.back()">返回</div>
          </div>
          <!-- <el-table :data="list" class="mt10" >
                    <el-table-column
                            type="index"
                            label="序号"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="tr_role_value"
                            label="姓名或微信昵称"
                            align="center">
                    </el-table-column>
                    <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="任务数量">
                    </el-table-column>
                      <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="报告数量">
                    </el-table-column>
                        <el-table-column
                            prop="tr_create_time"
                            align="center"
                            label="最后一次登录时间">
                    </el-table-column>
                    <el-table-column label="操作" align="center" width="160px">
                        <template slot-scope="scope">
                            <el-button size="mini" type="success" @click="edit(scope.row)">修改</el-button>
                            <el-popconfirm title="确定删除该条内容吗？" @confirm="del(scope.row)">
                                <el-button size="mini" type="danger" slot="reference">删除</el-button>
                            </el-popconfirm>
                        </template>
                    </el-table-column>
                </el-table> -->
        </el-card>
      </el-col>
      <!-- <el-col :span="12">
      <el-card>
        <div class="f-right border-b">
          <div class="flex1">巡查时间管理</div>
          <el-button icon="el-icon-plus" type="primary" @click="addList1()"
            >增加</el-button
          >
        </div>
        <table class="common-table mt20">
          <thead>
            <tr class="mt10">
              <th>巡查时间</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in list1" :key="index">
              <td class="common-add">
                <el-time-picker
                  class="flex1"
                  type="time"
                  value-format="HH:mm:ss"
                  placeholder="选择时间"
                  v-model="item.start_time"
                ></el-time-picker>
              </td>
              <td class="common-add">
                <el-select v-model="item.z_status">
                  <el-option :value="1" label="启用"></el-option>
                  <el-option :value="0" label="停用"></el-option>
                </el-select>
              </td>
              <td class="td-btn">
                <a class="clear-data" @click="del1(index)">
                  <i class="icon-tr-delete"></i>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
         <div class="btn-box">
                <div class="l-btn" @click="onSubmit1">保存</div>
                <div class="l-btn ml20" @click="$router.back()">返回</div>
            </div>
      </el-card>
    </el-col> -->
    </el-row>
    <el-backtop target=".common-body-style"></el-backtop>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      listWW: [],
      tabList: this.$store.state.user.userInfo.isWenwu ? [{ name: '文物巡查', id: 1 }] : [{ name: '消防巡查', id: 0 }],

      nowIndex: 0,

      list1: [{ start_time: '', z_status: 1 }],
    };
  },
  created() {
    // this.getList();
    this.getDatas();
  },
  methods: {
    changeTab(index, it) {
      this.nowIndex = index;
      this.getDatas();
    },
    onSubmit() {
      if (this.$store.state.user.userInfo.isWenwu) {
        this.$post('/xuncha/add', { get_area: this.listWW }).then((res) => {
          this.getDatas();

          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        });
      } else {
        this.$post('/xuncha/xcareaadd', { get_area: this.list }).then((res) => {
          this.getDatas();

          this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
        });
      }
    },
    onSubmit1() {
      //    return
      this.$post('/xuncha/xctimeadd', { get_time: this.list1 }).then((res) => {
        this.$message({
                message: '操作成功',
                type: 'success',
                duration: 700,
              });
      });
    },
    check() {
      var checked = true;

      if (this.list.length) {
        this.list.map((item) => {
          if (!item.x_company_id) {
            this.nowIndex = 0;
            this.$message.warning('请输入唯一标识');
            checked = false;
          }
        });

        return checked;
      } else {
        return checked;
      }
    },
    getDatas() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.getList();
      } else {
        this.getWWlist();
      }
    },
    getWWlist() {
      this.$post('/xuncha/xunchaareadetailWenWu', { c_company_num: this.$store.state.user.company.cCompanyNum }).then((res) => {
        console.log(res);
        this.listWW = res.data;
      });
    },
    getList() {
      // getUserList(this.params).then(res=>{
      //     this.total = res.data.count
      //     this.list = res.data.list
      // }).catch(err=>{

      // })
      this.$post('/xuncha/xunchaareadetail', { c_company_num: this.$store.state.user.company.cCompanyNum }).then((res) => {
        console.log(res);
        this.list = res.data;
      });
      // this.$post('/xuncha/xunchatimedetail').then(res=>{
      //               // return
      //               this.list1=res.data || []

      //           })
    },
    del(index) {
      if (this.list[index].x_company_id) {
        var x_company_id = this.list[index].x_company_id;
        this.$post('/xuncha/xcareaExist', { x_company_id, inspectionType: 1 }).then((res) => {
          if (res.code < 1000) {
            if (res.data == false) {
              this.list.splice(index, 1);
            } else {
              this.$message.warning(res.msg);
            }
          }
        });
      } else {
        this.list.splice(index, 1);
      }
    },
    del1(index) {
      if (this.listWW[index].x_company_id) {
        var x_company_id = this.listWW[index].x_company_id;
        this.$post('/xuncha/xcareaExist', { x_company_id, inspectionType: 2 }).then((res) => {
          if (res.code < 1000) {
            if (res.data == false) {
              this.listWW.splice(index, 1);
            } else {
              this.$message.warning(res.msg);
            }
          }
        });
      } else {
        this.listWW.splice(index, 1);
      }
    },
    addList() {
      if (this.tabList[this.nowIndex].id == 0) {
        this.list.unshift({ x_company_area: '' });
      } else {
        this.listWW.unshift({ x_company_area: '' });
      }
    },
    addList1() {
      this.list1.push({ start_time: '', z_status: 1 });
    },
  },
};
</script>

<style></style>
